import moment from 'moment';

import { Http } from '../../../support';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.cancelaciones.tickets = {
      ...state.modulo.cancelaciones.tickets,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.cancelaciones.tickets.data = {
      ...state.modulo.cancelaciones.tickets.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    state.modulo.cancelaciones.tickets = {
      ...state.modulo.cancelaciones.tickets,
      result: undefined,
      error: undefined,
      busy: true,
      pagination: {
        ...state.modulo.cancelaciones.tickets.pagination,
        ...params,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.cancelaciones.tickets;

    const body = {
      ...pagination,
      ...params,
    };
    const response = await Http.get(`/api/cancelaciones`, { params: body });

    store.setState((state) => {
      state.modulo.cancelaciones.tickets = {
        ...state.modulo.cancelaciones.tickets,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.cancelaciones.tickets.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
        filters: {
          ...params,
          from: params.from,
          to: params.to,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.cancelaciones.tickets.busy = false;
      state.modulo.cancelaciones.tickets.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.cancelaciones.tickets = {
      ...initialState,
    };
  });
};

const CancelacionesTicketListStore = {
  state: () => initialState,
  actions: {
    change,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default CancelacionesTicketListStore;
